// src/pages/Intro.jsx

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Intro = () => {
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        {/* 상단 배너 영역 */}
        <div className="sub_banner_area intro-field">
          <div className="sub_banner_back">
            <div className="banner_main_text">인사말</div>
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}융합원 소개{' > '}인사말
            </div>
          </div>
        </div>

        {/* 상단 드롭다운 내비게이션 영역 (기존 구조 유지) */}
        <div className="navi_area">
          <div className="navi_back_wrap">
            <div className="navi_back">
              <div className="navi_box" onClick={() => handleSelect(1)}>
                <div className="navi_main_text">융합원소개</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 1 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    알림 및 소식
                  </div>
                  <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                    사업분야
                  </div>
                  <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                    기업연구동
                  </div>
                  <div className="select_row" onClick={() => movePage('/meetingroom')}>
                    보유시설
                  </div>
                  <div className="select_row" onClick={() => movePage('/vision')}>
                    융합원소개
                  </div>
                </div>
              </div>

              <div className="navi_box" onClick={() => handleSelect(2)}>
                <div className="navi_main_text">인사말</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 2 && 'active'}`}>
                  <div className="select_row" onClick={() => movePage('/intro')}>
                    인사말
                  </div>
                  <div className="select_row" onClick={() => movePage('/vision')}>
                    비전 및 목표
                  </div>
                  <div className="select_row" onClick={() => movePage('/history')}>
                    연혁
                  </div>
                  <div className="select_row" onClick={() => movePage('/organization')}>
                    조직도
                  </div>
                  <div className="select_row" onClick={() => movePage('/introduce')}>
                    소개자료
                  </div>
                  <div className="select_row" onClick={() => movePage('/regulations')}>
                    관리규정
                  </div>
                  <div className="select_row" onClick={() => movePage('/map')}>
                    오시는 길
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 */}
        <div className="sub_main_area intro">
          {/* ★ 뷰포트 기준 고정 사이드바 (메인 컨텐츠 밖에 둔다) */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>융합원소개</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/intro')}`} onClick={() => movePage('/intro')}>
                <span>인사말</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/vision')}`} onClick={() => movePage('/vision')}>
                <span>비전 및 목표</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/history')}`} onClick={() => movePage('/history')}>
                <span>연혁</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/organization')}`} onClick={() => movePage('/organization')}>
                <span>조직도</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/introduce')}`} onClick={() => movePage('/introduce')}>
                <span>소개자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/regulations')}`} onClick={() => movePage('/regulations')}>
                <span>관리규정</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/map')}`} onClick={() => movePage('/map')}>
                <span>오시는 길</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 기존 메인 컨텐츠 */}
          <div className="sub_main_back intro">
            <div className="intro_top_box">
              <div className="intro_card">
                <div className="intro_box left">
                  <div className="left_top_box">
                    <div className="logo_box">
                      <div className="intro_logo"></div>
                    </div>
                    <div className="intro_title">
                      서해안 시대를 준비하는 <br />
                      새로운 <span>산학융합의 중심</span>
                    </div>
                  </div>

                  <div className="left_bottom_box">
                    <p className="intro_sub_heading">안녕하십니까. (사)충남산학융합원 홈페이지 방문을 환영합니다.</p>
                  </div>
                </div>

                <div className="intro_box right">
                  <div className="right_top_box">
                    <div className="image_box">
                      <div className="intro_image"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="intro_bottom_box">
              <div className="intro_main_text">새로운 산업화시대를 맞이하여 지역산업의 든든한 지원군이 되겠습니다.</div>
              <div className="intro_sub_text_row">
                충남산학융합원은 2017년 개원 후 충청남도 지역의 지역산업발전과 인재양성을 위해 다양한 지원사업을
                운영하고 있으며 중소기업과 대학 간의 협력을 통하여 지역 경제의 활성화를 목표로 하고 있습니다.
                <br />
                <br />
                특히, 최근 충남산학융합원은 미래내일 일경험 사업을 통해 청년들에게 다양한 일 경험 기회를 제공하고
                있으며, 지역 내 고용 생태계 활성화를 위해 노력함은 물론 지역 내 인적 자원 개발과 산업-학계R&amp;D협력을
                통해 지속적인 지역 성장을 도모하고 있습니다.
                <br />
                <br />
                앞으로 충남산학융합원은 지역 산업과 연계한 맞춤형 프로그램을 개발하여 지역경제를 활성화하고
                지역균형발전의 중심에서 지속 가능한 경제 생태계를 조성해 나가겠습니다.
                <br />
                <br />
                여러분의 많은 관심과 성원 부탁드립니다.
                <br />
                감사합니다.
              </div>
            </div>

            <br />

            <div className="intro_sign_box">
              <div className="sign_box left">
                <div className="sign_text_box main">
                  사단법인 <span>충남산학융합원</span>
                </div>
                <div className="sign_text_box name">
                  원장 <span>이종규</span>
                </div>
              </div>
              {/*
              <div className="sign_box right">
                <div className="sign_img"></div>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
